export const ACCEPT = 'accept';

export const MODERATED = 'moderated';

export const BANNED = 'banned';
